import { render, staticRenderFns } from "./studyDetails.vue?vue&type=template&id=355867ab&scoped=true"
import script from "./studyDetails.vue?vue&type=script&lang=js"
export * from "./studyDetails.vue?vue&type=script&lang=js"
import style0 from "./studyDetails.vue?vue&type=style&index=0&id=355867ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355867ab",
  null
  
)

export default component.exports